import React, { Component, forwardRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import "react-toastify/dist/ReactToastify.css";
import { fill_action } from "../../../actions/common_action/fillList_action";
import { Tab, Nav } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../utils/Loader";
import { responseError, toastError, toastSuccess, BASE_URL, categoryActionId, awardCategoryActionId, award_event_id, coordinatorListActionId, applicationTypeActionId, stateActionId, countryActionId, applicantTypePricingActionId } from "../../../utils/constants";
import Header from "../../../common_components/Header";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import moment from "moment";
import purify from 'dompurify'
import {
    getApplicationFormDetails_action, getApplicationFormDefaultDetails_action
} from "../../../actions/applicationModule_action/applicationForm_action";
import DatePicker from 'react-datepicker';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Resizer from "react-image-file-resizer";
import { insertUpdateApplicationFormSuvinScoring_action, verify_application_action } from "../../../actions/adminModule_action/adminModule_action";
import { Link, Element } from "react-scroll";
import Footer from "../../../common_components/Footer";
import { getAwardQuerywithAnswerComment_action, insertUpdateAwardQuery_action, insertUpdateAwardAnswer_action } from "../../../actions/common_action/awardQuery_action";
import { debounce } from "lodash";
import JoditEditor from "jodit-react";
import { juryReviewScoringPattern_action } from "../../../actions/juryModule_action/jury_dashboard_action";
import MobileHeader from "../../../common_components/mobileHeader";

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderColor: "#c9c9c9", // Blue border color
        boxShadow: "none",
        "&:hover": {
            borderColor: "#80bdff", // Blue border color on hover
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        borderRadius: "14px",
        padding: "4px",
        backgroundColor: "#00BCD4", // Blue background color for selected value
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "white", // Text color for selected value
        fontSize: "12px",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "white",
        "&:hover": {
            backgroundColor: "#00BCD4",
            color: "#fff", // Blue border color on hover
        }, // Remove icon color for selected value
    }),
};
class AdminApplicationViewForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isInstructionsOpen: '',
            isLoading: false,
            Event_Name: '',
            category_name: '',
            eligibility_criteria: '',
            screening_process: '',
            categoryFillList: [], awardProfileFillList: [],
            theme: '', category_names: '',
            important_instructions: '',
            applicationFormList: [],
            DeclarationData: '',
            statusId: 2,
            DeclarationFileName: '',
            DeclarationFileType: '',
            DeclarationFilePath: '',
            application_form_id: '',
            applicant_id: sessionStorage.getItem("user_id"),
            application_no: '', award_name: '',
            award_event_id: '',
            award_event_profile_id: '',
            declaration_file_path_db: '',
            display_Declaration_file_path: '',
            category_id: '',
            queryCoordinatorData: [],
            isIncomplete: false, status_name: '',
            isCollapse: false, verificationModalView: false, queryModalView: false, queryTo: '',
            verificationTitle: '', VerificationContent: '',
            verificationType: '', VerificationContent2: '', rejectRemark: null, outstanding: null,
            //query
            questionQuerydata: [],
            answerQuerydata: [],
            commentQuerydata: [],
            queryPostContent: '',
            queryDescription: '',
            sme_certificate_FileName: '',
            sme_certificate_FileType: '',
            sme_certificate_FilePath: '',
            sme_certificate_file_path: null,
            download_SME_Certificate_file_path: '', applicantTypeID: '', countryId: '', stateName: '', cityName: '', pinCode: ''
            , applicantTypeList: [], countryList: [], applicantTypeName: '', download_Declaration_file_path: '',
            //scoring
            scoringFields: [], selectedSectionFieldId: null, scoringfieldSelected: null, scoringData: [], suvinContent: '', isReplyMode: false, question_id: null
        };
        this.debouncedUpdateState = {};
        ['queryDescription'].forEach(field => {
            this.debouncedUpdateState[field] = debounce(this.updateState.bind(this, field), 1000);
        });
    }

    componentDidMount() {
        const { user_id } = this.state;
        this.getFillList(categoryActionId, user_id, "", "");
        this.getFillList(countryActionId, user_id, "", "");
        this.getFillList(awardCategoryActionId, user_id, "", award_event_id);
        this.getFillList(applicationTypeActionId, user_id, "", "")
        this.getFillList(applicantTypePricingActionId, user_id, "", "")

        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }

        setTimeout(() => {
            {
                (sessionStorage.getItem("role_id") == 2 || sessionStorage.getItem("role_id") == 4) ? (
                    this.props.navigate("/login")
                ) : <></>
            }
        }, 10);

        this.setState({
            user_id: sessionStorage.getItem("user_id") || "",
        });
        if (this.props.location.state != null) {
            this.setState({
                award_event_profile_id: this.props.location.state.award_event_profile_id,
                application_form_id: this.props.location.state.application_form_id
            })
        }
        setTimeout(() => {
            this.getApplicationFormDefaultDetails()

        }, 200);
    }
    getFillList(value, user_id, keyword, keyvalue) {
        // this.setState({ isLoading: true });
        this.props
            .fill_action(
                value,
                user_id == "" || user_id == null ? null : user_id,
                keyword != "" ? keyword : null,
                keyvalue != "" ? keyvalue : null
            )
            .then((data) => {
                if (data.error != 1) {
                    if (value == categoryActionId) {
                        this.setState({
                            categoryFillList: data.data,
                        });
                    }
                    if (value == awardCategoryActionId) {
                        this.setState({
                            awardProfileFillList: data.data,
                        });
                    }
                    if (value == applicationTypeActionId) {
                        this.setState({
                            applicantTypeList: data.data,
                        });
                    }
                    if (value == stateActionId) {
                        this.setState({
                            stateList: data.data,
                            tempStateList: data.data,
                        })
                    }
                    if (value == countryActionId) {
                        this.setState({ countryList: data.data })
                    }
                    if (value == applicantTypePricingActionId) {
                        if (data.data != '') {
                            this.setState({ isAplicationIsPaid: data.data[0]['price'] != 0 ? true : false })
                        }

                    }
                } else {
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getApplicationFormDefaultDetails() {
        const { award_event_profile_id, application_form_id } = this.state;
        this.setState({ isLoading: true })
        this.props.getApplicationFormDefaultDetails_action(award_event_profile_id)
            .then((data) => {
                if (data.error != 1) {
                    if (data.InputFieldData != '' && data.SectionNameData != '') {
                        this.setState({ applicationBlanked: false })
                    } else {
                        this.setState({ applicationBlanked: true })
                    }
                    if (data.application_form_id != '') {
                        this.setState({ application_form_id: data.application_form_id[0]['application_form_id'] })
                    }
                    if (data.InstrunctionData != '') {
                        this.setState({
                            category_id: data.InstrunctionData[0]["category_id"],
                            category_name: data.InstrunctionData[0]["category_name"],
                            category_names: data.InstrunctionData[0]["category_names"],
                            theme: data.InstrunctionData[0]["theme"],
                            eligibility_criteria: data.InstrunctionData[0]["eligibility_criteria"],
                            screening_process: data.InstrunctionData[0]["screening_process"],
                            important_instructions: data.InstrunctionData[0]["important_instructions"],
                            award_event_id: data.InstrunctionData[0]["award_event_id"],
                            award_name: data.InstrunctionData[0]["award_name"],
                            award_event_profile_id: data.InstrunctionData[0]["award_event_profile_id"],
                            DeclarationData: data.InstrunctionData[0]["award_event_profile_declaration"],
                        })
                        const { applicantTypeList } = this.state
                        const applicant_type_ids = data.InstrunctionData[0]["applicant_type_ids"] != null ? data.InstrunctionData[0]["applicant_type_ids"].split(',') : []
                        const finalArray = []
                        applicant_type_ids.length > 0 && applicant_type_ids.map((item) => {
                            for (let i = 0; i < applicantTypeList.length; i++) {
                                if (applicantTypeList[i]['applicant_type_id'] == item) {
                                    finalArray.push(applicantTypeList[i])
                                }
                            }
                        })
                        this.setState({ applicantTypeList: finalArray })
                    }

                    const finalArray = []
                    if (data.SectionNameData != '') {
                        data.SectionNameData.map((item) => {
                            if (data.InputFieldData != '') {
                                const array = []
                                for (let i = 0; i < data.InputFieldData.length; i++) {
                                    data.InputFieldData[i]['applicant_response'] = null
                                    data.InputFieldData[i]['FileName'] = null
                                    data.InputFieldData[i]['FileType'] = null
                                    data.InputFieldData[i]['FilePath'] = null
                                    data.InputFieldData[i]['application_form_id'] = null
                                    data.InputFieldData[i]['application_no'] = null
                                    data.InputFieldData[i]['award_name'] = null
                                    data.InputFieldData[i]['application_status_id'] = 2
                                    if (item.award_event_profile_form_section_id == data.InputFieldData[i]['award_event_profile_form_section_id']) {
                                        if (data.OptionsData != '') {
                                            const optionData = []
                                            for (let j = 0; j < data.OptionsData.length; j++) {
                                                if (data.InputFieldData[i]['award_event_profile_section_fields_id'] == data.OptionsData[j]['award_event_profile_section_fields_id']) {
                                                    if (data.InputFieldData[i]['controltype_Name'] == 'Dropdown - Multi-Select') {
                                                        const obj = {
                                                            label: data.OptionsData[j]['options'],
                                                            value: data.OptionsData[j]['options'],
                                                        }
                                                        optionData.push(obj)
                                                    } else if ((data.InputFieldData[i]['controltype_Name'] == 'Checkbox - Single-Select') || (data.InputFieldData[i]['controltype_Name'] == 'Checkbox - Multi-Select')) {
                                                        data.OptionsData[j]['isChecked'] = false
                                                        optionData.push(data.OptionsData[j])
                                                    } else {
                                                        optionData.push(data.OptionsData[j])
                                                    }
                                                }
                                            }
                                            data.InputFieldData[i]['optionData'] = optionData
                                            array.push(data.InputFieldData[i])
                                        } else {
                                            array.push(data.InputFieldData[i])
                                        }
                                    }
                                }
                                if (array.length > 0) {
                                    array.sort((a, b) => a.seq_no - b.seq_no)
                                    finalArray.push({ section_name: item.section_name, seq_no: item.seq_no, array })
                                }
                            } else {
                                finalArray.push(item)
                            }
                        })
                    }
                    setTimeout(() => {
                        if (finalArray.length > 0) {
                            finalArray.sort((a, b) => a.seq_no - b.seq_no)
                            this.setState({ applicationFormList: finalArray }, () => {
                                this.getApplicationFormDetails()
                                this.getAwardQuerywithAnswerComment()
                                this.getJuryReviewScoringPattern(award_event_profile_id, application_form_id)
                            })
                        } else {
                            this.setState({ isLoading: false })
                        }
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    responseError(data);

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }
    getAwardQuerywithAnswerComment = () => {
        const { award_event_id, award_event_profile_id, application_form_id } = this.state;
        this.setState({ isLoading: true });
        this.props.getAwardQuerywithAnswerComment_action(award_event_id, award_event_profile_id, application_form_id, '')
            .then((data) => {
                if (data.error !== 1) {
                    const questionQuerydata = data.data[0];
                    const answerQuerydata = data.data[1];
                    const updatedQuestionQuerydata = questionQuerydata.map((question) => {
                        const matchingAnswers = answerQuerydata.filter(
                            (answer) => answer.question_id === question.question_id
                        );
                        return { ...question, answerQueryData: matchingAnswers };
                    });
                    console.log(questionQuerydata)
                    console.log(answerQuerydata)
                    console.log(updatedQuestionQuerydata)
                    this.setState({
                        questionQuerydata: updatedQuestionQuerydata,
                        // answerQuerydata,
                        isLoading: false,
                    });
                } else {
                    this.setState({ isLoading: false });
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    onReplyToggle(question_id) {
        if (this.state.isReplyMode) {
            this.setState({ isReplyMode: false, question_id: null, queryPostContent: '' })
        } else {
            this.setState({ isReplyMode: true, question_id: question_id })
        }
    }
    replyQuery(question_id) {
        const { queryPostContent, answer_id, award_event_profile_id, application_form_id, questionQuerydata } = this.state;
        if (queryPostContent == '') {
            toastError('Kindly Fill Content')
        } else {
            const role_id = sessionStorage.getItem('role_id')
            const queryTo = questionQuerydata.find(item => item.question_id == question_id).role_id
            this.props.insertUpdateAwardAnswer_action(question_id, answer_id, queryPostContent, application_form_id, sessionStorage.getItem('user_name'), sessionStorage.getItem('email_address'), role_id, queryTo)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ queryPostContent: '', isReplyMode: false, question_id: '' }, () => {
                            this.getAwardQuerywithAnswerComment(award_event_id, award_event_profile_id, application_form_id);
                        })
                    } else {
                        toastError(data.msg)
                    }
                }).catch((e) => console.log(e))
        }
    }
    postQuery() {
        const { queryPostContent, award_event_id, award_event_profile_id, application_form_id, queryDescription, question_id, queryTo } = this.state;
        if (queryPostContent == '' || queryPostContent == null || queryPostContent == undefined) {
            toastError('Query cannot be blank.')
        } else {
            this.props.insertUpdateAwardQuery_action(question_id, award_event_id, award_event_profile_id, application_form_id, queryPostContent, queryDescription, 'query', null, parseInt(queryTo), sessionStorage.getItem('user_name'), sessionStorage.getItem('email_address'))
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ queryDescription: '', queryPostContent: '', rejectRemark: '', queryTo: '', queryModalView: false });
                        setTimeout(() => {
                            this.getAwardQuerywithAnswerComment();
                        }, 200);
                    } else {
                        toastError(data.msg)
                    }
                }).catch((e) => console.log(e))
        }
    }
    handleQueryEditor = (newContent, type) => {
        this.debouncedUpdateState[type](newContent);
    }
    updateState(field, value) {
        this.setState({ [field]: value });
    }
    getJuryReviewScoringPattern = (award_event_profile_id, application_form_id) => {
        this.setState({ isLoading: true });
        this.props.juryReviewScoringPattern_action(award_event_profile_id, application_form_id)
            .then((data) => {
                if (data.error !== 1) {
                    const AddScoringData = data.data[0].map(field => ({
                        applicant_scoring_id: null,
                        application_form_id: application_form_id,
                        award_event_id: parseInt(award_event_id),
                        award_event_profile_id: field.award_event_profile_id,
                        scoring_pattern_id: field.award_event_profile_scoring_pattern_id,
                        section_id: field.section_fields_id,
                        score: null,
                        max_score: field.max_score,
                    }))
                    this.setState({
                        scoringFields: data.data[0],
                        scoringData: data.data[1].length > 0 ? data.data[1] : AddScoringData,
                        application_status_id: data.data[2][0].application_status_id,
                        isLoading: false,
                    });
                } else {
                    this.setState({ isLoading: false });
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    submitApplicationSuvinScoring(application_form_suvin_scoring_data_id, award_event_profile_id, award_event_profile_scoring_pattern_id, suvinContent) {
        const { award_event_id, application_form_id } = this.state;
        if (suvinContent == '' || suvinContent == null || suvinContent == undefined) {
            toastError('Cannot be blank.')
        } else {
            this.props.insertUpdateApplicationFormSuvinScoring_action(application_form_suvin_scoring_data_id, award_event_id, award_event_profile_id, application_form_id, award_event_profile_scoring_pattern_id, suvinContent)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess('Submitted Successfully')
                        this.setState({ suvinContent: '' }, () => this.getJuryReviewScoringPattern(award_event_profile_id, application_form_id))
                    } else {
                        toastError(data.msg)
                    }
                }).catch((e) => console.log(e))
        }
    }
    highlightField(section_fields_id) {
        const sectionElement = document.getElementById(`section-${section_fields_id}`);
        if (sectionElement) {
            sectionElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        this.setState({
            selectedSectionFieldId: section_fields_id,
            scoringfieldSelected: true,
        });
    }

    calculateTotalScore = () => {
        const { scoringData } = this.state;
        return scoringData.reduce((total, item) => total + item.score, 0);
    };
    getApplicationFormDetails() {
        const { application_form_id, applicationFormList } = this.state

        this.props.getApplicationFormDetails_action(application_form_id)
            .then((data) => {
                if (data.error != 1) {
                    applicationFormList.map((item) => {
                        for (let i = 0; i < item.array.length; i++) {
                            for (let j = 0; j < data.data.length; j++) {
                                if (item.array[i]['award_event_profile_section_fields_id'] == data.data[j]['award_event_profile_section_fields_id']) {
                                    item.array[i]['applicant_response'] = data.data[j]['applicant_response']
                                    item.array[i]['application_form_id'] = data.data[j]['application_form_id']
                                    item.array[i]['application_no'] = data.data[j]['application_no']
                                    item.array[i]['application_status_id'] = data.data[j]['application_status_id']
                                    if (data.data[j]['file_path'] != null) {
                                        item.array[i]['file_path'] = data.data[j]['file_path']
                                        const file = data.data[j]["file_path"].split(`${data.data[j]['application_form_id']}/`)
                                        item.array[i]['FileName'] = file[1]
                                    }
                                    if (item.array[i]['controltype_Name'] == 'Dropdown - Multi-Select') {
                                        const array = item.array[i]['applicant_response'] != null ? item.array[i]['applicant_response'].split(',') : []
                                        const finalArray = []
                                        if (item.array[i].optionData != undefined) {
                                            for (let k = 0; k < item.array[i].optionData.length; k++) {
                                                if (array.includes(item.array[i].optionData[k]['label'])) {
                                                    finalArray.push({
                                                        label: item.array[i].optionData[k]['label'],
                                                        value: item.array[i].optionData[k]['label'],
                                                    })
                                                }
                                            }
                                        }
                                        item.array[i]['Multi_Select_value'] = finalArray
                                    }
                                    if (item.array[i]['controltype_Name'] == 'Checkbox - Single-Select') {
                                        if (item.array[i].optionData != undefined) {
                                            for (let k = 0; k < item.array[i].optionData.length; k++) {
                                                if (item.array[i].optionData[k]['award_event_profile_section_fields_options_id'] == data.data[j]['award_event_profile_section_fields_options_id']) {
                                                    item.array[i].optionData[k]['isChecked'] = true
                                                    item.array[i]['applicant_response'] = item.array[i].optionData[k]['options']
                                                } else {
                                                    item.array[i].optionData[k]['isChecked'] = false
                                                }
                                            }
                                        }
                                    }
                                    if (item.array[i]['controltype_Name'] == 'Checkbox - Multi-Select') {
                                        const array = item.array[i]['applicant_response'] != null ? item.array[i]['applicant_response'].split(' :&: ') : []
                                        if (item.array[i].optionData != undefined) {
                                            for (let k = 0; k < item.array[i].optionData.length; k++) {
                                                if (array.includes(item.array[i].optionData[k]['options'])) {
                                                    item.array[i].optionData[k]['isChecked'] = true
                                                } else {
                                                    item.array[i].optionData[k]['isChecked'] = false
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    })
                    this.setState({ applicationFormList: applicationFormList }, () => {
                        if (data.hdrdata != '') {
                            if (data.hdrdata[0]["declaration_file_path"] != null && data.hdrdata[0]["declaration_file_path"] != '') {
                                const file = data.hdrdata[0]["declaration_file_path"].split(`${data.hdrdata[0]['application_form_id']}/`)
                                const displayFile = data.hdrdata[0]["declaration_file_path"].split('.')
                                this.setState({
                                    DeclarationFileName: file[1],
                                    download_Declaration_file_path: displayFile[1] + '.' + displayFile[2],
                                })
                            }
                            if (data.hdrdata[0]["sme_certificate_file_path"] != null && data.hdrdata[0]["sme_certificate_file_path"] != '') {
                                const file = data.hdrdata[0]["sme_certificate_file_path"].split(`${data.hdrdata[0]['application_form_id']}/`)
                                const displayFile = data.hdrdata[0]["sme_certificate_file_path"].split('.')
                                this.setState({
                                    sme_certificate_FileName: file[1],
                                    download_SME_Certificate_file_path: displayFile[1] + '.' + displayFile[2],
                                })
                            }
                            this.setState({
                                statusId: data.hdrdata[0]['application_status_id'],
                                application_form_id: data.hdrdata[0]['application_form_id'],
                                application_no: data.hdrdata[0]['application_no'],
                                declaration_file_path_db: data.hdrdata[0]["declaration_file_path"],
                                sme_certificate_file_path: data.hdrdata[0]["sme_certificate_file_path"],
                                applicantTypeID: data.hdrdata[0]["applicant_type_id"],
                                applicantTypeName: data.hdrdata[0]["applicant_type"],
                                status_name: data.hdrdata[0]["status_name"],
                                paymentType: data.hdrdata[0]["payment_type"],
                                is_paid: data.hdrdata[0]["is_paid"],
                                is_gst_applicable: data.hdrdata[0]["is_gst_applicable"],
                                cityName: data.hdrdata[0]["city"],
                                stateName: data.hdrdata[0]["state"],
                                countryId: data.hdrdata[0]["country_id"],
                                pinCode: data.hdrdata[0]["pincode"],
                                isIncomplete: data.hdrdata[0]["isIncomplete"],
                                outstanding: data.hdrdata[0]["outstanding"]
                            })
                            if (data.hdrdata[0]["country_id"] == 91) {
                                this.getFillList(stateActionId, '', data.hdrdata[0]["country_id"], '')
                            }
                            this.getFillList(28, this.state.user_id, data.hdrdata[0]["applicant_type_id"], award_event_id);
                        }
                    })
                    this.setState({ isLoading: false })
                }
                else {
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }
    toggleQueryModal() {
        const { queryModalView, queryPostContent } = this.state
        if (queryModalView) {
            this.setState({
                queryModalView: false,
                queryTo: ''
            });
        } else {
            if (queryPostContent == '' || queryPostContent == null || queryPostContent == undefined) {
                toastError('Query cannot be blank.')
            } else {
                this.setState({
                    queryModalView: true,
                });
            }
        }
    }
    toggleVerificationModal = (type) => {
        const { verificationModalView } = this.state
        if (verificationModalView) {
            this.setState({
                verificationModalView: false,
                verificationTitle: '',
                VerificationContent: '',
                VerificationContent2: '', rejectRemark: null,
                verificationType: ''
            });
        } else {
            this.setState({
                verificationModalView: true,
                verificationTitle: type == 1 ? 'Mark Incomplete' : type == 4 ? 'Reject Application' : type == 5 ? 'Verify Application' : null,
                VerificationContent: type == 1 ? 'Do you really want to Mark Incomplete this Application Form ?' : type == 4 ? 'Do you really want to Reject this Application Form ?' : type == 5 ? 'Do you really want to Verify this Application Form ?' : null,
                VerificationContent2: type == 1 ? 'This will allow applicant to recheck the form with incomplete/incorrect details and submit again.' :
                    type == 4 ? 'This will Reject the Application Form and will not allow to proceed further.' :
                        type == 5 ? 'This will confirm the Verification of form details filled by applicant and allow the Application to proceed further' : null,
                verificationType: type
            });
        }
    }
    verifyApplication(status) {
        const { application_form_id, rejectRemark } = this.state
        if (status == 4 || status == 1) {
            if (rejectRemark == null || rejectRemark == '') {
                toastError('Kindly Enter Remark')
                return
            }
        }
        this.props.verify_application_action(application_form_id, status, rejectRemark)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess(`Application has been tagged as ${status == 4 ? "Rejected" : status == 5 ? "Verified" : "incomplete"} SuccessFully`)
                    this.getApplicationFormDefaultDetails()
                    if (status == 4 || status == 1) {
                        this.setState({ queryPostContent: rejectRemark, queryTo: 1 }, () => {
                            this.postQuery()
                        })
                    }
                    this.setState({ isLoading: false, statusId: status, verificationModalView: false })
                }
                else {
                    this.setState({ isLoading: false, verificationModalView: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    navigateBackApplicationList() {
        this.props.navigate('/adminApplicationList');
    }
    render() {
        const { isLoading, eligibility_criteria, screening_process,
            theme, category_names, important_instructions, applicationFormList, statusId, DeclarationFileName,
            award_name, isIncomplete, questionQuerydata, queryPostContent,
            isCollapse, verificationModalView, verificationTitle, VerificationContent, verificationType, VerificationContent2,
            sme_certificate_FileName, download_SME_Certificate_file_path,
            applicantTypeID, countryId, stateName, cityName, pinCode, applicantTypeList, applicantTypeName, countryList, rejectRemark,
            application_no, status_name, outstanding, scoringFields, selectedSectionFieldId, scoringfieldSelected, scoringData,
            suvinContent, queryModalView, queryTo, download_Declaration_file_path, isReplyMode, question_id
        } = this.state;
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>
                    <main id="main">

                        <div className="website-view">
                            <Header data={[8]} />
                        </div>
                        <div className="mobile-view">
                            <MobileHeader data={[8]} />
                        </div>
                        <section class='header_margin_top'>
                            <div class="container-fluid">
                                <h4 class="page-title ">
                                    <span style={{ fontSize: '24px', color: '#f1c841', fontWeight: '600' }}>Application No: {application_no} </span>
                                </h4>
                                <div class="d-flex" style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                                    <h4 class="page-title">  Award Category: {award_name ? award_name : ''}</h4>
                                    <div className="d-flex">
                                        <a
                                            className="btn btn-danger btn-sm create_btn add_additional_days_btn mb-3 d-flex align-items-center ml-2"
                                            style={{ width: "min-content", height: '31px' }}
                                        >
                                            <i className="ri-information-line "></i>  <Link
                                                to="query"
                                                class="nav-link"
                                                style={{ cursor: "pointer", color: 'white' }}
                                                smooth={true}
                                                duration={500}
                                                offset={-100}
                                            >
                                                Query
                                            </Link>
                                        </a>
                                        {status_name != '' && <span class="status draft ml-2">{status_name} </span>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-9">
                                        <div class="card-body p-0 ">
                                            <div className="company_info ">
                                                <fieldset>
                                                    <div
                                                        className="panel-heading accordion-toggle collapsed "
                                                        data-toggle="collapse"
                                                        data-parent="#accordion"
                                                        data-target="#collapseOne"
                                                        aria-expanded={isCollapse}
                                                        onClick={() =>
                                                            this.setState({
                                                                isCollapse: !isCollapse,
                                                            })
                                                        }
                                                    >
                                                        <legend class="panel-title"><i style={{ verticalAlign: 'middle' }} class="ri-information-line "></i><span style={{ cursor: 'pointer', fontSize: '16px' }} >Instructions</span> <span style={{ marginLeft: '6px' }}>(<a style={{ fontSize: '14px', textDecoration: 'underline', color: '#007bffe8' }}>{isCollapse ? ' Show Less ' : ' Show More '}</a></span>)</legend>
                                                    </div>

                                                    <div class="panel-group" id="accordion">
                                                        <div class="panel panel-default">
                                                            <div
                                                                id="collapseOne"
                                                                className={`panel-collapse p-0 collapse ${isCollapse ? "show" : ""
                                                                    }`}
                                                            >
                                                                <div class="panel-body" style={{ padding: '5px 10px' }}>
                                                                    <div class="form-group" style={{ marginTop: '35px' }}>
                                                                        <div class="row">

                                                                            {/* <table class="table table-bordered">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th scope="col">Category</th>
                                                                                        <th scope="col">{category_names}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td style={{ width: '20%' }}>asasasas aasa aasas sasasa</td>
                                                                                        <td>asasa sasas</td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table> */}


                                                                            <div class="col-md-12">
                                                                                <div className="awards-row" style={{ borderTop: '1px solid #e0e0e0' }}>
                                                                                    <div className="label">Category</div>
                                                                                    <div className="content">
                                                                                        {category_names}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="awards-row">
                                                                                    <div className="label">Theme</div>
                                                                                    <div className="content">
                                                                                        <div dangerouslySetInnerHTML={{
                                                                                            __html: purify.sanitize(theme)
                                                                                        }}
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <div className="awards-row">
                                                                                    <div className="label">Eligibility</div>
                                                                                    <div className="content">
                                                                                        <div dangerouslySetInnerHTML={{
                                                                                            __html: purify.sanitize(eligibility_criteria)
                                                                                        }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="awards-row">
                                                                                    <div className="label">Screening Process</div>
                                                                                    <div className="content">
                                                                                        <div dangerouslySetInnerHTML={{
                                                                                            __html: purify.sanitize(screening_process)
                                                                                        }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="awards-row">
                                                                                    <div className="label">Important Instructions</div>
                                                                                    <div className="content">
                                                                                        <div dangerouslySetInnerHTML={{
                                                                                            __html: purify.sanitize(important_instructions)
                                                                                        }}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                {applicationFormList.length > 0 && applicationFormList.map((data, index) => (
                                                    <fieldset key={index}>
                                                        <legend>{data.section_name}</legend>
                                                        <div className="outside_input_field ">
                                                            <div class="row">
                                                                {data.array.length > 0 && data.array.map((item, i) => (
                                                                    <>
                                                                        {
                                                                            (index == 0 && i == 0) &&
                                                                            <>
                                                                                <div className="col-4 mb-2">
                                                                                    <label>Applicant Type<span className="mendatory_class">*</span></label>
                                                                                    <select
                                                                                        className="form-control"
                                                                                        name="TimeSlot"
                                                                                        disabled={true}
                                                                                        value={applicantTypeID}
                                                                                    >
                                                                                        <option value={''}>Select</option>
                                                                                        {applicantTypeList.map((data) => (
                                                                                            <option
                                                                                                key={data.applicant_type_id}
                                                                                                value={data.applicant_type_id}
                                                                                            >
                                                                                                {data.applicant_name}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                </div>
                                                                                {applicantTypeName.toLowerCase() == 'msme organization' ?
                                                                                    <div class="col-md-4">
                                                                                        <div class="mb-0">
                                                                                            <label>
                                                                                                MSME Certificate<span className="mendatory_class">*</span>
                                                                                            </label>
                                                                                            {sme_certificate_FileName == '' ?
                                                                                                <div class=" mt-1" >
                                                                                                    <input type="file" name="files[]" multiple
                                                                                                        disabled={true} class="custom-file-input form-control"
                                                                                                        id="customFile"
                                                                                                    // onChange={(e) => this.onSME_CertificateFilePick(e, e.target.files)}
                                                                                                    />
                                                                                                    <label class="custom-file-label" for="customFile"
                                                                                                    >Upload Declaration Form</label>
                                                                                                </div> :
                                                                                                <div className='membership_file' >
                                                                                                    {download_SME_Certificate_file_path != null && download_SME_Certificate_file_path != '' ?
                                                                                                        <span className='overflow-membership'><a
                                                                                                            href={BASE_URL.split('/api')[0] + download_SME_Certificate_file_path}
                                                                                                            target='blank' style={{ textDecoration: 'none', color: '#414244' }}>{sme_certificate_FileName}</a></span> :
                                                                                                        <span className='overflow-membership'>{sme_certificate_FileName}</span>
                                                                                                    }

                                                                                                </div>
                                                                                            }
                                                                                        </div>
                                                                                    </div> :
                                                                                    <></>
                                                                                }
                                                                                <div class="col-md-4">
                                                                                    <label>Country<span className="mendatory_class">*</span></label>
                                                                                    <select id="state" name="Entry Type" class="form-control"
                                                                                        // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                        value={countryId}
                                                                                        disabled={true}
                                                                                    // onChange={e => this.onCountryId(e)}
                                                                                    >
                                                                                        <option value=''>Select</option>
                                                                                        {countryList.length > 0 && countryList.map(item => (
                                                                                            <option
                                                                                                key={item.country_id}
                                                                                                value={item.country_id}>
                                                                                                {item.CountryName}
                                                                                            </option>
                                                                                        ))}

                                                                                    </select>
                                                                                </div>
                                                                                <div class="col-md-4">
                                                                                    <label>State<span className="mendatory_class">*</span></label>
                                                                                    <input value={stateName} type="text"
                                                                                        disabled={true}
                                                                                        class="form-control" required
                                                                                        // onChange={(e) => this.onStateSearch(e)}
                                                                                        autocomplete="off"
                                                                                        maxLength={30}
                                                                                    />
                                                                                </div>
                                                                                <div class="col-md-4">
                                                                                    <label>City<span className="mendatory_class">*</span></label>
                                                                                    <input value={cityName} type="text"
                                                                                        disabled={true}
                                                                                        class="form-control" required
                                                                                        // onChange={(e) => this.setState({ cityName: e.target.value, CityNameErr: '' })}
                                                                                        autocomplete="off"
                                                                                        maxLength={30}
                                                                                    />

                                                                                </div>
                                                                                <div class="col-md-4">
                                                                                    <label> {
                                                                                        countryId == '91' || countryId == '' ? 'Pincode' : 'ZipCode'
                                                                                    }<span className="mendatory_class">*</span></label>
                                                                                    <input value={pinCode} type="text"
                                                                                        class="form-control" required
                                                                                        disabled={true}
                                                                                        // onChange={(e) => this.setState({ pinCode: e.target.value, pincodeErr: '' })}
                                                                                        autocomplete="off"
                                                                                        maxLength={10}
                                                                                    />

                                                                                </div>
                                                                            </>
                                                                        }
                                                                        {(item.controltype_Name == 'Text Box - Numeric' || item.controltype_Name == 'Text Box - AlphaNumeric' || item.controltype_Name == 'Text Box - Phone Number' || item.controltype_Name == 'Text Box - Email' || item.controltype_Name == 'Text Box - Website') &&
                                                                            <div class="col-md-6 mt-2 mb-0" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                    <label>
                                                                                        {item.fieldname}
                                                                                        {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                    </label>
                                                                                    <input
                                                                                        type="text"
                                                                                        value={item.applicant_response}
                                                                                        disabled={true}
                                                                                        maxLength={item.max_length}
                                                                                        // onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                        class="form-control"
                                                                                    // placeholder={`Enter ${item.fieldname}`}
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Text Box - Decimal') && <div class="col-md-6 mt-1">
                                                                            <div class="form-group">
                                                                                <label>
                                                                                    {item.fieldname}
                                                                                    {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    value={item.applicant_response}
                                                                                    disabled={true}
                                                                                    maxLength={item.max_length}
                                                                                    onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                    class="form-control"
                                                                                // placeholder={`Enter ${item.fieldname}`}
                                                                                />
                                                                                {<span className='text-danger text-start text-left d-block mt-1'>{item.is_mandatory && item.submitValidation && (item.applicant_response == '' || item.applicant_response == null) ? `Please Enter ${item.fieldname}` : ''}</span>}
                                                                            </div>
                                                                        </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Multiline Text Box') &&
                                                                            <div class="col-md-6 mt-2" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                    <label>
                                                                                        {item.fieldname}
                                                                                        {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                    </label>
                                                                                    <textarea
                                                                                        cols={4}
                                                                                        rows={6}
                                                                                        type="text"
                                                                                        disabled={true}
                                                                                        value={item.applicant_response}
                                                                                        maxLength={item.max_length}
                                                                                        // onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                        class="form-control"
                                                                                    // placeholder={`Enter ${item.fieldname}`}
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Date Picker') &&
                                                                            <div class="col-md-6 mt-2" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                    <label>
                                                                                        {item.fieldname}
                                                                                        {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                    </label>
                                                                                    <DatePicker className="form-control"
                                                                                        dateFormat="dd-MM-yyyy"
                                                                                        disabled={true}
                                                                                        selected={item.applicant_response != null ? new Date(item.applicant_response) : item.applicant_response}
                                                                                        // onChange={(date) => this.handleInput(date, item.controltype_Name, data.seq_no, i)}
                                                                                        peekNextMonth
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                        placeholderText="DD/MM/YYYY"
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Dropdown - Single-Select') &&
                                                                            <div class="col-md-6 mt-2" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                    <label>
                                                                                        {item.fieldname}
                                                                                        {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                    </label>
                                                                                    <select
                                                                                        class="form-select"
                                                                                        disabled={true}
                                                                                        value={item.applicant_response}
                                                                                    // onChange={(e) => this.handleInput(e.target.value, item.controltype_Name, data.seq_no, i)}
                                                                                    >
                                                                                        <option>Select</option>
                                                                                        {item.optionData != undefined && item.optionData.length > 0 &&
                                                                                            item.optionData.map((option) => (
                                                                                                <option
                                                                                                    key={option.options}
                                                                                                    value={option.options}
                                                                                                >
                                                                                                    {option.options}
                                                                                                </option>
                                                                                            ))}
                                                                                    </select>

                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Dropdown - Multi-Select') &&
                                                                            <div class="col-md-6 mt-2" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                    <label>
                                                                                        {item.fieldname}
                                                                                        {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                    </label>
                                                                                    <Select
                                                                                        isMulti
                                                                                        isDisabled
                                                                                        // onChange={(e) => this.handleInput(e, item.controltype_Name, data.seq_no, i)}
                                                                                        styles={customStyles}
                                                                                        value={item.Multi_Select_value}
                                                                                        options={item.optionData}
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'Checkbox - Single-Select' || item.controltype_Name == 'Checkbox - Multi-Select') &&
                                                                            <div class="col-md-6 mt-2" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                    <>
                                                                                        <label>
                                                                                            {item.fieldname}
                                                                                            {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                        </label>
                                                                                        <div className="bg only_checkbox d-flex flex-row" style={{ flexWrap: 'wrap' }}>
                                                                                            {item.optionData.length > 0 && item.optionData.map((option, objIndex) => (
                                                                                                // <div class="col-md-3 mb-3" key={objIndex}>
                                                                                                <div className="" >

                                                                                                    <label
                                                                                                        className="lebel-dis d-flex"
                                                                                                        htmlFor={`ServiceCheck-${objIndex}-${item.fieldname}`}
                                                                                                        style={{ color: "#979797", marginLeft: '12px' }}
                                                                                                    >
                                                                                                        <input type="checkbox" className="mr-2"
                                                                                                            disabled={true}
                                                                                                            checked={option.isChecked}
                                                                                                            // onClick={(e) => this.handleInput(e.target.checked, item.controltype_Name, data.seq_no, i, option.options)}
                                                                                                            id={`ServiceCheck-${objIndex}-${item.fieldname}`} />
                                                                                                        {option.options}
                                                                                                    </label>
                                                                                                    <span></span>
                                                                                                </div>
                                                                                                // </div>
                                                                                            ))}
                                                                                        </div>

                                                                                    </>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {(item.controltype_Name == 'File Upload') &&
                                                                            <div class="col-md-6 mt-2" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                    <label>
                                                                                        {item.fieldname}
                                                                                        {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                    </label>
                                                                                    <div className='membership_file' >
                                                                                        <span className='overflow-membership' > <a href={BASE_URL.split('/api')[0] + '/' + (item.file_path != null && item.file_path.split('./')[1])} title={item.FileName}
                                                                                            target='blank'> {item.FileName}</a></span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                ))}
                                                <fieldset className="pb-6">
                                                    <legend> Declaration</legend>
                                                    {download_Declaration_file_path ? <>
                                                        <button type="button" class="btn btn-outline-success mr-1 p-1 px-2 mt-3 view-draft-btn">
                                                            <a href={BASE_URL.split('/api')[0] + download_Declaration_file_path} title={DeclarationFileName}
                                                                target='_blank' style={{ textDecoration: 'none' }}><i class="ri-external-link-line"></i>{" "}View Declaration</a>
                                                        </button>
                                                    </> : <>
                                                        <button disabled type="button" class="btn btn-outline-success mr-1 p-1 px-2 mt-3 view-draft-btn">
                                                            <a style={{ textDecoration: 'none' }}><i class="ri-external-link-line"></i>{" "}Declaration Not Uploaded</a>
                                                        </button>
                                                    </>}
                                                    {/* <div className="row w-100">
                                                <div className="content col-12" style={{
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '10px',
                                                    textAlign: 'center',
                                                    fontFamily: "'Book Antiqua', serif",
                                                    fontSize: '16px',
                                                    lineHeight: '1.5',
                                                }}>
                                                    <div dangerouslySetInnerHTML={{
                                                        __html:purify.sanitize(DeclarationData)
                                                    }}
                                                    />
                                                </div>
                                            </div> */}
                                                </fieldset>
                                            </div>
                                        </div>
                                    </div>
                                    {applicationFormList.length > 0 ? <>
                                        <div className="col-md-3 col-12">
                                            <div className="apply-application border">
                                                <p className="application-title-header">Score</p>
                                                {scoringFields.length > 0 ? (
                                                    scoringFields.map((data, index) => (
                                                        <div
                                                            key={index}
                                                            className="application-card"
                                                            onClick={() => this.highlightField(data.section_fields_id)}
                                                            style={
                                                                scoringfieldSelected && selectedSectionFieldId === data.section_fields_id
                                                                    ? { background: 'rgb(255 233 210)', padding: '10px' }
                                                                    : null
                                                            }
                                                        >
                                                            <p className="application-title">
                                                                {data.marking_pattern_name}{' '}
                                                                {data.description ? <i className="ri-information-line" title={data.description}></i> : null}
                                                            </p>
                                                            <div className="reply-box mb-5">
                                                                <textarea
                                                                    className="w-90"
                                                                    rows={2}
                                                                    placeholder="Add Info for Jury"
                                                                    value={data.suvinContent || ''}
                                                                    onChange={(e) => {
                                                                        this.setState((prevState) => {
                                                                            const updatedFields = prevState.scoringFields.map((field) => {
                                                                                if (field.section_fields_id === data.section_fields_id) {
                                                                                    return {
                                                                                        ...field,
                                                                                        suvinContent: e.target.value,
                                                                                    };
                                                                                }
                                                                                return field;
                                                                            });
                                                                            return { scoringFields: updatedFields };
                                                                        });
                                                                    }}
                                                                ></textarea>

                                                                <button
                                                                    className="send-button"
                                                                    onClick={() =>
                                                                        this.submitApplicationSuvinScoring(
                                                                            data.application_form_suvin_scoring_data_id,
                                                                            data.award_event_profile_id,
                                                                            data.award_event_profile_scoring_pattern_id, data.suvinContent
                                                                        )
                                                                    }
                                                                >
                                                                    <i className="ri-send-plane-2-line"></i>
                                                                </button>
                                                            </div>
                                                            <p className="company-name">
                                                                {/* {scoringData.find(item => item.section_id === data.section_fields_id)?.score || 0} / */}
                                                                Max Score: {data.max_score}
                                                            </p>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <></>
                                                )}

                                                {scoringFields.length > 0 && (
                                                    <>
                                                        <div className="application-card">
                                                            <p className="application-title">Total</p>
                                                            {scoringFields.find(item => item.round_id === 1) ? <>
                                                                <p className="company-name">
                                                                    ROUND 1 SCORE:{" "}
                                                                    {scoringData.reduce((total, item) => total + item.score, 0) ? scoringData.reduce((total, item) => total + item.score, 0) : 0}
                                                                    /{" "}
                                                                    {scoringFields.reduce((total, field) => total + field.max_score, 0)}
                                                                </p>
                                                            </> : <></>}
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </> : <></>}
                                </div>
                                <div class="d-flex justify-content-start ml-2 mb-3">
                                    {isIncomplete ? (
                                        <>
                                            <div className="mr-3 mt-3 mb-3">
                                                <button className="btn btn-outline-warning" disabled>
                                                    Mark Incompleted
                                                </button>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            {(statusId == 3) ? (
                                                <>
                                                    <div className="mr-3 mt-3 mb-3">
                                                        <button className="btn btn-warning" onClick={() => this.toggleVerificationModal(1)}>
                                                            Mark Incomplete
                                                        </button>
                                                    </div>
                                                    <div className="mr-3 mt-3 mb-3">
                                                        <button className="btn btn-danger" onClick={() => this.toggleVerificationModal(4)}>
                                                            Reject
                                                        </button>
                                                    </div>
                                                    {outstanding == 0 ? <>
                                                        <div className="mr-3 mt-3 mb-3">
                                                            <button className="btn btn-success" onClick={() => this.toggleVerificationModal(5)}>
                                                                Verify
                                                            </button>
                                                        </div>
                                                    </> : <>
                                                        <div className="mr-3 mt-3 mb-3">
                                                            <button className="btn btn-outline-danger" disabled>
                                                                Payment Pending
                                                            </button>
                                                        </div></>}
                                                </>
                                            ) : (
                                                <>
                                                    {statusId > 4 ? (
                                                        <div className="mx-3  mb-3 mt-3">
                                                            <button className="btn btn-outline-success" disabled>
                                                                Verified
                                                            </button>
                                                        </div>
                                                    ) : statusId > 3 ? (
                                                        <div className="mx-3  mb-3 mt-3">
                                                            <button className="btn btn-outline-warning" disabled>
                                                                Rejected
                                                            </button>
                                                        </div>
                                                    ) : isIncomplete === 1 ? (
                                                        <div className="mx-3  mb-3 mt-3">
                                                            <button className="btn btn-outline-danger" disabled>
                                                                Tagged as Incomplete
                                                            </button>
                                                        </div>
                                                    ) : null}
                                                </>
                                            )}
                                        </>
                                    )}

                                    <div class="mt-3 mb-3">
                                        <a
                                            onClick={() => this.navigateBackApplicationList()}
                                            class="btn btn-dark"
                                        >
                                            Back
                                        </a>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="company_info">
                                        <Element name="query" className="element">
                                            <fieldset>
                                                <legend>Query</legend>
                                                <div className="outside_input_field">
                                                    <div className="query-container">
                                                        {questionQuerydata.length > 0 ? (
                                                            questionQuerydata.map((data) => (
                                                                <React.Fragment key={data.question_id}>
                                                                    <div className="query">
                                                                        <div className="user-icon ps">
                                                                            {data.question_author
                                                                                .split(" ")
                                                                                .map((word) => word[0])
                                                                                .join("")
                                                                                .toUpperCase()}
                                                                        </div>
                                                                        <div className="query-content">
                                                                            <div className="query-header row">
                                                                                <div className="col-10">
                                                                                    <span className="user-name">{data.question_author}</span>
                                                                                    <span className="timestamp px-2">
                                                                                        {data.question_time} | {moment(data.question_date).format('DD-MMM-YYYY')}
                                                                                    </span>
                                                                                </div>
                                                                                {data.created_by_id !== parseInt(sessionStorage.getItem('user_id')) && (
                                                                                    <div className="col-1 text-right">
                                                                                        <i
                                                                                            className={(isReplyMode && (question_id === data.question_id)) ? "ri-close-line querycancel" : 'ri-reply-line'}
                                                                                            onClick={() => this.onReplyToggle(data.question_id)}
                                                                                        ></i>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <p className="query-text" style={{ marginLeft: '68px' }}>
                                                                                {data.title}
                                                                            </p>
                                                                            {/* <p className="query-text">
                  <div dangerouslySetInnerHTML={{ __html:purify.sanitize(data.question_content) }} />
                </p> 
                */}
                                                                        </div>
                                                                    </div>

                                                                    {/* Render Answers */}
                                                                    {data?.answerQueryData?.length > 0 && data.answerQueryData.map((answer) => (
                                                                        <div className="query" style={{ marginLeft: '50px' }} key={answer.answer_id}>
                                                                            <div className="user-icon ps">
                                                                                {answer.answer_author
                                                                                    .split(" ")
                                                                                    .map((word) => word[0])
                                                                                    .join("")
                                                                                    .toUpperCase()}
                                                                            </div>
                                                                            <div className="query-content">
                                                                                <div className="query-header row">
                                                                                    <div className="col-10">
                                                                                        <span className="user-name">{answer.answer_author}</span>
                                                                                        <span className="timestamp px-2">
                                                                                            {answer.answer_time} | {moment(answer.answer_date).format('DD-MMM-YYYY')}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <p className="query-text">
                                                                                    <div dangerouslySetInnerHTML={{ __html: purify.sanitize(answer.answer_content) }} />
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    ))}

                                                                    {/* Render Reply Box for specific question */}
                                                                    {isReplyMode && (question_id === data.question_id) && (
                                                                        <div className="reply-box mb-5">
                                                                            <div className="user-icon vs">
                                                                                {sessionStorage.getItem("user_name") &&
                                                                                    sessionStorage
                                                                                        .getItem("user_name")
                                                                                        .split(" ")
                                                                                        .map((word) => word[0])
                                                                                        .join("")
                                                                                        .toUpperCase()}
                                                                            </div>
                                                                            <textarea
                                                                                style={{ marginLeft: '10px' }}
                                                                                rows={2}
                                                                                value={queryPostContent}
                                                                                maxLength={2000}
                                                                                className="reply-input rounded-0"
                                                                                placeholder="reply to the query"
                                                                                onChange={(e) => this.setState({ queryPostContent: e.target.value })}
                                                                            ></textarea>
                                                                            <button className="send-button" onClick={() => this.replyQuery(data.question_id)}>
                                                                                <i className="ri-send-plane-2-line"></i>
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </React.Fragment>
                                                            ))
                                                        ) : (
                                                            <div className="query">
                                                                <div className="query-content">
                                                                    <p className="query-text text-center">
                                                                        No Query Yet!... Start a conversation.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Render general Query box if not in reply mode */}
                                                        {!isReplyMode && (
                                                            <div className="reply-box mb-5">
                                                                <div className="user-icon vs">
                                                                    {sessionStorage.getItem("user_name") &&
                                                                        sessionStorage
                                                                            .getItem("user_name")
                                                                            .split(" ")
                                                                            .map((word) => word[0])
                                                                            .join("")
                                                                            .toUpperCase()}
                                                                </div>
                                                                <textarea
                                                                    style={{ marginLeft: '10px' }}
                                                                    rows={2}
                                                                    type="text"
                                                                    value={queryPostContent}
                                                                    placeholder="Post a Query"
                                                                    maxLength={2000}
                                                                    className="reply-input rounded-0"
                                                                    onChange={(e) => this.setState({ queryPostContent: e.target.value })}
                                                                ></textarea>
                                                                <button className="send-button" onClick={() => this.toggleQueryModal()}>
                                                                    <i className="ri-send-plane-2-line"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </Element>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <Modal show={queryModalView}>
                            <Modal.Header>
                                <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                    <h6>Submit Query</h6>
                                </Modal.Title>
                                <span
                                    onClick={() => this.toggleQueryModal()}
                                    style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                                >
                                    X
                                </span>
                            </Modal.Header>
                            <Modal.Body>
                                <div>
                                    <p className="query-text">Query to submit for?</p>
                                    <label
                                        htmlFor={`queryToCheck`}
                                        className="lebel"
                                        style={{ color: "#979797" }}
                                    >For Applicant {" "}
                                        <input
                                            type="radio"
                                            id={`queryToCheck`}
                                            checked={queryTo == 4 ? queryTo : 0}
                                            onChange={() =>
                                                this.setState({ queryTo: 4 })
                                            }
                                        />
                                    </label>
                                    <label
                                        htmlFor={`queryToCheck`}
                                        className="lebel"
                                        style={{ color: "#979797" }}
                                    >For All Jury {" "}
                                        <input
                                            type="radio"
                                            id={`queryToCheck`}
                                            checked={queryTo == 2 ? queryTo : 0}
                                            onChange={() =>
                                                this.setState({ queryTo: 2 })
                                            }
                                        />
                                    </label>
                                </div>
                            </Modal.Body>

                            <Modal.Footer style={{ justifyContent: 'left' }}>
                                <div class="row">
                                    <div class="col-md-4">
                                        <button
                                            onClick={() => this.postQuery()}
                                            class="btn btn-warning mr-2"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Post
                                        </button>
                                    </div>
                                    <div class="col-md-4">
                                        <button
                                            onClick={() => this.toggleQueryModal()}
                                            class="btn btn-dark"
                                            style={{ cursor: 'pointer', width: 'auto' }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>

                            </Modal.Footer>
                        </Modal>
                        <Modal show={verificationModalView}>
                            <Modal.Header>
                                <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                    <h6>{verificationTitle} </h6>
                                </Modal.Title>
                                <span
                                    onClick={() => this.toggleVerificationModal(verificationType)}
                                    style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                                >
                                    X
                                </span>
                            </Modal.Header>
                            <Modal.Body>
                                <div>
                                    <p className="mb-1 mt-1 com-font">
                                        {VerificationContent}
                                    </p>
                                    <p className="mb-1 mt-1 com-font">{VerificationContent2}</p>
                                    {verificationType == 5 ? <></> : <>
                                        <hr />
                                        <label>Remark</label>
                                        <textarea type="text" className="form-control" placeholder="Enter Remark" maxLength={500} value={rejectRemark} onChange={(e) => this.setState({ rejectRemark: e.target.value })} rows={14} ></textarea>
                                    </>}
                                </div>
                            </Modal.Body>

                            <Modal.Footer style={{ justifyContent: 'left' }}>
                                <div class="row">
                                    <div class="col-md-4">
                                        <button
                                            onClick={() => this.verifyApplication(verificationType)}
                                            class="btn btn-warning mr-2"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Yes
                                        </button>
                                    </div>
                                    <div class="col-md-4">
                                        <button
                                            onClick={() => this.toggleVerificationModal(verificationType)}
                                            class="btn btn-dark"
                                            style={{ cursor: 'pointer', width: 'auto' }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>

                            </Modal.Footer>
                        </Modal>
                    </main>
                    <Footer />

                    <ToastContainer />
                </>
            </>
        );
    }
}
export default withRouter(
    connect(null, {
        getApplicationFormDefaultDetails_action, getApplicationFormDetails_action,
        fill_action, verify_application_action, getAwardQuerywithAnswerComment_action, insertUpdateAwardQuery_action,
        juryReviewScoringPattern_action, insertUpdateApplicationFormSuvinScoring_action, insertUpdateAwardAnswer_action
    })(AdminApplicationViewForm)
);
